import React, { useState } from 'react';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';
import { deleteJobDescription } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const CONFIRMATION_TEXT = 'I understand, delete';

const DeleteJobDescriptionForm = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { onResponse, onError, closeDeleteJobDescriptionModal } = useBiopharmaGroupActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const [confirmationInput, setConfirmationInput] = useState('');

  const title = biopharmaGroupState?.deleteJobDescription?.title || 'this job description';

  const handleSubmit = () => {
    if (confirmationInput !== CONFIRMATION_TEXT) return;
    deleteJobDescription({
      onResponse,
      onError,
      body: {
        authenticityToken,
        deleteJobDescription: biopharmaGroupState?.deleteJobDescription,
      },
    });
  };

  const isConfirmed = confirmationInput === CONFIRMATION_TEXT;

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Deleting <strong>{title}</strong> will permanently destroy all associated:
        <ul>
          <li>Taggings</li>
          <li>Match Scores</li>
          <li>Job Prospects</li>
        </ul>
        This action cannot be undone.
      </FormInstruction>

      <Field label={`Type "${CONFIRMATION_TEXT}" to confirm`}>
        <Input
          type="text"
          value={confirmationInput}
          onChange={(e) => setConfirmationInput(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeDeleteJobDescriptionModal()}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
            disabled={!isConfirmed}
          >
            Delete Job Description
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default DeleteJobDescriptionForm;
